<template>
  <section class="members">
    <div class="members__wrapper">
      <BaseTitle :text="titleText" class="members__title" />
      <MembersList />
      <BaseBtn
        :text="btnText"
        to="participants-page"
        @click.native="getCategoryId"
        :customClass="'default'"
      />
    </div>
  </section>
</template>

<script>
import MembersList from '~/components/MembersList'

export default {
  name: 'MembersBlock',
  components: {
    MembersList
  },
  computed: {
    titleText() {
      return this.messages.index.members.title
    },
    btnText() {
      return this.messages.index.members.btnText
    }
  },
  methods: {
    getCategoryId() {
      this.$store.commit('participants/SET_ID', 'category1')
      this.$store.commit('participants/SET_ACTIVE_CATEGORY', 'category1')
    }
  }
}
</script>

<style lang="scss">
.members {
  &__wrapper {
    @include container;

    position: relative;
    padding: 100px 16px 38px;
    text-align: center;

    &::before {
      @include horizontal-center;

      content: '';
      position: absolute;
      z-index: -1;
      top: 34px;
      width: 667px;
      height: 999px;
      background: url('~/static/img/members-bg-shape@mb.svg') no-repeat center;
      background-size: cover;
    }
  }

  &__title {
    margin: 0 0 30px;
  }

  &__list {
    margin: 0 0 40px;
    padding: 0;
    list-style: none;
  }

  &__caption {
    width: 100%;
    margin: auto 0 0 0;
  }

  &__text {
    margin: 0 0 auto 0;
  }
}

@include media-min($tablet-width) {
  .members {
    &__wrapper {
      padding: 0 25px 75px;

      &::before {
        top: -150px;
        right: -110px;
        left: initial;
        width: 1209px;
        height: 896px;
        background: url('~/static/img/members-bg-shape@tl.svg') no-repeat center;
        background-size: cover;
        transform: translate(0, 0);
      }
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 60px;
    }

    &__item {
      width: 348px;
      height: 236px;

      &:not(:last-of-type) {
        margin-bottom: 0;
      }

      &:nth-of-type(2n) {
        margin-top: 22px;
      }

      &:nth-of-type(2n + 1) {
        margin-right: 22px;
      }
    }
  }
}

@include media-min($desktop-width) {
  .members {
    &__wrapper {
      padding: 0 60px 60px;

      &::before {
        top: -263px;
        right: -270px;
        width: 1864px;
        height: 1410px;
        background: url('~/static/img/members-bg-shape@dt.svg') no-repeat center;
        background-size: cover;
      }
    }

    &__title {
      margin-bottom: 60px;
    }

    &__item {
      width: 560px;
      height: 380px;

      &:nth-of-type(2n) {
        margin-top: 60px;
      }

      &:nth-of-type(2n + 1) {
        margin-right: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/MembersBlock.vue